import React, { useContext } from "react";
import { Tooltip, Box, Typography, Grid } from "@mui/material";
import { useHistory } from "react-router-dom";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ThemeContext } from "../theme/ThemeContext";

const HeaderToolbar = (props) => {
  let history = useHistory();
  const { darkMode } = useContext(ThemeContext);
  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid
          container
          spacing={1}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            width: "100vh",
          }}
        >
          {props.back_button ? (
            <Grid
              item
              onClick={history.goBack}
              style={{
                paddingLeft: "2.5px",
              }}
            >
              <Box
                sx={{
                  padding: "5px",
                  borderRadius: "50%",
                  "&:hover": {
                    backgroundColor: darkMode
                      ? "rgb(255 255 255 / 8%)"
                      : "rgb(0 0 0 / 4%)",
                  },
                }}
              >
                <Box
                  sx={{
                    cursor: "pointer",
                    borderRadius: "50%",
                    height: "40px",
                    width: "40px",
                    backgroundColor: darkMode ? "rgb(14, 42, 65)" : "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    pointerEvents: "none",
                  }}
                >
                  <ArrowBackIcon
                    sx={{ color: darkMode ? "#fff" : "#3D4977" }}
                    fontSize="small"
                  />
                </Box>
              </Box>
            </Grid>
          ) : (
            <></>
          )}
          <Grid
            item
            style={{
              margin: "16px, 0",
              marginTop: props.dashboardPanel ? props.dashboardPanel : "",
            }}
          >
            <Typography variant="h3" style={{ color: darkMode ? "#fff" : "" }}>
              {props.title}
            </Typography>
          </Grid>
        </Grid>
        {props.src ? (
          <Box
            style={{
              textAlign: "center",
              padding: "10px",
              backgroundColor: process.env.REACT_APP_BG_ICON,
              borderRadius: "50%",
              cursor: "pointer",
              // width:'45px', height:'45px'
            }}
          >
            <Tooltip title={props.tooltipTitle}>
              <img
                alt="..."
                src={props.src}
                onClick={props.onClick}
                style={{ width: "22px" }}
              />
            </Tooltip>
          </Box>
        ) : (
          <></>
        )}
      </Box>
    </>
  );
};
export default HeaderToolbar;
